export const errorMessages = {
  constituencyTicketsCantContinue:
    'You may only order one type of discount ticket at a time. Please update your cart to continue.'
}
